import { Source, Layer, Marker } from 'react-map-gl/mapbox';
import { Box } from '@mui/material';
import { LineGeometry } from '../../../../models/topography.models.tsx';
import { primary } from '../../../../constants/theme/colors.tsx';
import { LoadingToast } from '../../../../components/loading-toast/loading-toast.tsx';
import { Fragment } from 'react';
import {
  getTwoMiddlePoints,
  spaceBetweenTwoPoints,
} from '../../utils/coords-math.ts';

interface TopographySourceProps {
  topographyData: LineGeometry[];
  loading: boolean;
}

export const TopographySource = ({
  topographyData,
  loading,
}: TopographySourceProps) => {
  return (
    <>
      {loading && (
        <LoadingToast
          message="Loading Topography Data..."
          isLoading={loading}
          isError={topographyData.length === 0 && !loading}
          isSuccess={topographyData.length > 0 && !loading}
          toastId="topography-loading-toast"
        />
      )}
      {topographyData &&
        topographyData.map((feat: LineGeometry, key) => {
          const middlePoints = getTwoMiddlePoints(feat.geometry.coordinates);
          const markerPosition = spaceBetweenTwoPoints(
            middlePoints[0],
            middlePoints[1]
          );

          return (
            <Fragment key={key}>
              <Source
                type="geojson"
                data={{
                  type: 'FeatureCollection',
                  features: [
                    {
                      type: 'Feature',
                      properties: {},
                      geometry: {
                        type: 'LineString',
                        coordinates: feat.geometry.coordinates,
                      },
                    },
                  ],
                }}
              >
                <Layer
                  {...{
                    id: `topography${key}`,
                    type: 'line',
                    paint: {
                      'line-color': primary.light,
                      'line-width': 4,
                      'line-opacity': 0.6,
                    },
                  }}
                />
              </Source>
              <Marker
                longitude={markerPosition[0]}
                latitude={markerPosition[1]}
                anchor="bottom"
              >
                <Box
                  className="button-tooltip topography-tooltip"
                  data-showing-setback={false}
                  data-key={`topography${key}`}
                  style={{
                    color: 'white',
                    fontSize: '18px',
                  }}
                >
                  {feat.properties.elevation} Feet
                </Box>
              </Marker>
            </Fragment>
          );
        })}
    </>
  );
};
